import color from 'color'
import styled from 'styled-components'

import { getBrandingColor } from 'utils/branding'

export const StyledFormContainer = styled.div`
  padding: 30px 0 0 0;
  background: ${color(getBrandingColor('primary-color')).alpha(0.1).rgb().string()};
`
